import { FC } from "react";
import { NavLink } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const HeaderBackButton: FC<{ navigateTo: string; tooltip?: string }> = ({
  navigateTo,
  tooltip,
}) => {
  return (
    <Tooltip title={tooltip || "Zurück"}>
      <NavLink to={navigateTo}>
        <IconButton>
          <ArrowBack />
        </IconButton>
      </NavLink>
    </Tooltip>
  );
};

export default HeaderBackButton;
